import React, { ReactNode, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../redux";
import { UserType } from "../models/enums/userType.enum";
import TermsAgreedModal from "../components/forms/TermsAgreedModal";
import { getCurrentUser } from "../redux/users/actions";

interface AcceptTermsProtectionProps {
  children: ReactNode;
}

const AcceptTermsProtection: React.FC<AcceptTermsProtectionProps> = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector((state: AppState) => state.user);
  const currentUser = user.currentUser;

  const mustAcceptTerms =
    !!currentUser &&
    (!currentUser.terms_agreed_at || currentUser.terms_agreed_at === "") &&
    currentUser.user_type !== UserType.Admin;

  const handleAgree = useCallback(
    (terms_agreed_at: string) => {
      if (!currentUser) {
        return;
      }

      dispatch(
        getCurrentUser({
          ...currentUser,
          terms_agreed_at,
          terms_agreed: true,
        })
      );
    },
    [dispatch, currentUser]
  );

  return (
    <>
      {children}
      {currentUser ? (
        <TermsAgreedModal
          open={mustAcceptTerms}
          onAgree={handleAgree}
          currentUser={currentUser}
        />
      ) : null}
    </>
  );
};

export default AcceptTermsProtection;
